import {produce} from "immer";
import {DEFAULT_ENVIRONMENT, THEME_COLORS} from "../../Globals.ts";
import {isMobileApp} from "../../Utils/misc/envNameUtils.ts";

interface EnvironmentObj {
    environment: string;
    projectName: string | null;
    systemDetails: any | null;
    vscode: any;
    date: string;
    projectEmbeddingsLastUpdated: string | null;
    uiVersionTimestamp: number;
    userApplicationVersion: string | null;
    latestApplicationVersion: string | null;
    anthropicApiKey: string | null;
    openAiApiKey: string | null;
    xAiApiKey: string | null;
    geminiApiKey: string | null;
}

export const environmentSlice = (set: any, get: any) => ({
    environmentObj: {
        environment: DEFAULT_ENVIRONMENT,
        projectName: null,
        systemDetails: null,
        vscode: null,
        date: new Date().toDateString(),
        projectEmbeddingsLastUpdated: null,
        uiVersionTimestamp: Date.now(),
        userApplicationVersion: null,
        latestApplicationVersion: null,
        anthropicApiKey: null,
        openAiApiKey: null,
        xAiApiKey: null,
        geminiApiKey: null
    },
    setEnvironmentObj: (newEnvironmentObj: Partial<EnvironmentObj>) => set(produce((state: any) => {
        if (newEnvironmentObj.environment) {
            if (isMobileApp(newEnvironmentObj.environment)) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    functionName: "themeChange",
                    data: [{ theme: get().settingsObj.theme, color: THEME_COLORS }]
                }));
            } else if (newEnvironmentObj.environment === "chrome") {
                window.parent.postMessage({
                        functionName: 'themeChange',
                        data: [{ theme: get().settingsObj.theme }]
                    },
                    '*');
            }
        }

        Object.assign(state.environmentObj, newEnvironmentObj);
    }))
});
